var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"hide-default-footer":"","no-data-text":_vm.$t('message.nao_ha_conteudo')},scopedSlots:_vm._u([{key:"item.linha",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.linha)+"\n    ")]}},{key:"item.descricao",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.descricao)+"\n    ")]}}])}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","id":"importacaoDialog-table-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.fechar'))+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/custom/abbrasil/spa/importacao/ImportacaoDialogErros.vue?vue&type=template&id=3690c2be&lang=html&
// module id = 1422
// module chunks = 28